// extracted by mini-css-extract-plugin
export var button = "notification-settings-form-module--button--39e52";
export var buttonBox = "notification-settings-form-module--button-box--20429";
export var checkbox = "notification-settings-form-module--checkbox--af476";
export var checkboxAll = "notification-settings-form-module--checkbox-all--38686";
export var form = "notification-settings-form-module--form--2a72a";